import { Injectable } from "@angular/core";

@Injectable()
export class EndpointService {
  constructor() {
    //
  }

  /**
   * @description Creates and returns the url string for the api request.
   * @returns string;
   */
  public getUrl(version: string, capability: string, endpoint: string): string {
    const url = `${window["API_HOST"]}${version}/${capability}/${endpoint}`;
    return url;
  }
}
